import api from 'configs/api';
import { ICluster } from 'interfaces/Cluster';
import { IRequestListResponse } from 'interfaces/RequestListResponse';

const endpointUrl = 'cluster';

export const getClusters = async () => {
  const url = '/cluster';
  const { data } = await api.get<IRequestListResponse<ICluster>>(url);
  return data;
};

export const getCluster = async () => {
  const url = '/cluster/listar/instalacao/';
  const { data } = await api.get<IRequestListResponse<ICluster>>(url);
  return data;
};

export const postClusterFilter = async (params: {
  idsInstalacoes: string[];
}) => {
  const url = `${endpointUrl}/filtro`;
  const { data } = await api.post<IRequestListResponse<ICluster>>(url, params);
  return data;
};

export const postClusterAnomalyFilter = async (params: {
  idsInstalacoes: string[];
}) => {
  const url = `${endpointUrl}/anomaly/filter-with-anomaly`;
  const { data } = await api.post<IRequestListResponse<ICluster>>(url, params);
  return data;
};

export const getClusterFilterByDescription = async (description: string) => {
  const url = `${endpointUrl}/filtroCompletoPorDescricao/${description}`;
  const { data } = await api.get<IRequestListResponse<ICluster>>(url);
  return data;
};
